import React from "react";
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { CurrencyEnums } from "models/enums";
//#endregion
//#region components
import TopTodoCard from "components/todos/_partials/topTodoCard";
import { TitledContainerInner, EntityCardContent, SimpleViewPanel } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const BankPortalSigningTodo: React.FC<TodoCardProps> = (props) => {
  const info: WintSuperkollAPIModel.BankPortalSigningInformation | undefined = props.item.bankPortalSigning;
  const payments = info?.payments ?? [];
  const total = payments.reduce((sum, p) => sum + (p.amount?.value ?? 0), 0);
  const earliestDueMs = payments.reduce<number | undefined>((min, p) => {
    const t = new Date(p.dispatchedExecutionDate).getTime();
    if (Number.isNaN(t)) return min;
    return min === undefined || t < min ? t : min;
  }, undefined);
  const earliestDue = earliestDueMs !== undefined ? new Date(earliestDueMs) : props.item.dueDate;

  return (
    <EntityCardContent
      topTodoCard={
        <TopTodoCard
          item={props.item}
          descriptionHeadingOne={`${LocalizationHelperInstance.getFormattedCurrency(total)} ${
            CurrencyEnums.CurrencyCode.SEK
          }`}
          descriptionHeadingTwo={`${payments.length} ${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.Pc
          )}`}
          footerText={`${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.Due_Date
          )}: ${earliestDue ? LocalizationHelperInstance.getFormattedDate(earliestDue) : ""}`}
        />
      }
      todoMainSection={
        <TitledContainerInner
          header={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Todos.BankPortalSigning_Header
          )}
          subHeader={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Todos.BankPortalSigning_SubHeader
          )}
        />
      }
      infoViewer={
        <SimpleViewPanel
          appearance="sm"
          title={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Todos.BankPortalSigning_PaymentsTitle
          )}
        >
          <table className={cssExports.bankPortalSigningPaymentsTable}>
            <thead>
              <tr>
                <th scope="col">
                  {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Receiver)}
                </th>
                <th scope="col">
                  {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Amount)}
                </th>
                <th scope="col">
                  {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Date)}
                </th>
              </tr>
            </thead>
            <tbody>
              {payments.map((p) => (
                <tr key={p.paymentId}>
                  <td>{p.receiverName}</td>
                  <td>
                    {LocalizationHelperInstance.getFormattedCurrency(p.amount?.value ?? 0)} {p.amount?.type}
                  </td>
                  <td>{LocalizationHelperInstance.getFormattedDate(new Date(p.dispatchedExecutionDate))}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </SimpleViewPanel>
      }
    ></EntityCardContent>
  );
};

export default BankPortalSigningTodo;
